<template lang="pug">
  td.col.favorite(:class="job.favored ? 'on' : ''")
    span(@click="toggle") お気に入り
</template>

<script>
  import { mapActions } from 'vuex'
  import { HumanInfoMessages } from '../../constants'

  export default {
    props: ['job', 'updateFavorForIndex'],
    data () {
      return {
        favored: this.job.favored,
      }
    },
    methods: {
      ...mapActions('jobList', ['add', 'remove']),
      async toggle () {
        if (this.job.favored) {
          this.$router.push({ name: 'JobList' })
          return
        }

        this.$store.commit('common/lockGlobal')
        try {
          await this.add({ id: this.job.id })

          if (this.updateFavorForIndex) {
            this.$store.commit('job/favor', { ids: this.job.id, newFavored: !this.job.favored })
          }
          this.$store.dispatch('common/pushToastInfo', {
            info: HumanInfoMessages.ADDED_TO_MYLIST,
          })
          this.$emit('update')
        } catch (e) {
          this.$store.dispatch('common/pushToastError', {
            error: e,
          })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobTableFavoriteStar.vue